import "core-js/modules/web.dom-collections.iterator.js";
import React, { useState, useEffect, useMemo, useCallback } from "react";
import ExpandLessIcon from "@pixel/assets/icons/ExpandLess";
import ExpandMoreIcon from "@pixel/assets/icons/ExpandMore";
import Box from "../Box";
import Stack from "../Stack";
import Button from "../Button";
import Typography from "../Typography";
import ErrorBoundary from "../ErrorBoundary";
import { ListSearchFilterTypes } from "./ListSearchFilter.types";
import ListFilterSingleSelect from "./ListFilterSingleSelect";
import ListFilterMultiSelect from "./ListFilterMultiSelect";
import ListFilterSingleRadio from "./ListFilterSingleRadio";
import ListFilterMultiCheckbox from "./ListFilterMultiCheckbox";
import ListFilterText from "./ListFilterText";
import ListFilterNumber from "./ListFilterNumber";
import ListFilterNumberRange from "./ListFilterNumberRange";
import ListFilterCustom from "./ListFilterCustom";
export const createEmptyAppliedFilter = searchFilter => {
  return {
    searchFilterId: searchFilter.id,
    displayLabel: searchFilter.label,
    filterValues: []
  };
};
export const searchFilterTyped = untypedSearchFilter => {
  let searchFilter = null;
  switch (untypedSearchFilter.type) {
    case ListSearchFilterTypes.SingleSelect:
    case ListSearchFilterTypes.SingleRadio:
      searchFilter = untypedSearchFilter;
      break;
    case ListSearchFilterTypes.MultiSelect:
    case ListSearchFilterTypes.MultiCheckbox:
      searchFilter = untypedSearchFilter;
      break;
    case ListSearchFilterTypes.Text:
      searchFilter = untypedSearchFilter;
      break;
    case ListSearchFilterTypes.Number:
      searchFilter = untypedSearchFilter;
      break;
    case ListSearchFilterTypes.NumberRange:
      searchFilter = untypedSearchFilter;
      break;
    case ListSearchFilterTypes.Custom:
      searchFilter = untypedSearchFilter;
      break;
    default:
      throw new Error("Search Filter type: ".concat(untypedSearchFilter.type, " not supported"));
  }
  return searchFilter;
};
const ListSearchFilter = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    searchFilter,
    appliedSearchFilter,
    labelClear = "Clear",
    onChangeAppliedFilter = (searchFilter, newAppliedFitler) => {}
  } = _ref;
  const {
    open = null,
    canClose = true,
    label
  } = searchFilter;
  const getOpenState = () => {
    if (canClose == false) return true;
    if (open == true) return true;
    if (open == false) return false;
    if (open == null && !!appliedSearchFilter) return true;
    return false;
  };
  const [openState, setOpenState] = useState(getOpenState());
  // console.log("aaaa", searchFilter.id, open, canClose, openState, appliedSearchFilter);

  useEffect(() => {
    if (openState !== open) {
      setOpenState(getOpenState());
    }
  }, [open]);
  const handleToggleOpen = () => {
    if (!canClose) return;
    setOpenState(!openState);
  };
  const handleClearFilter = useCallback(e => {
    e.stopPropagation();
    onChangeAppliedFilter(searchFilter, null);
  }, [onChangeAppliedFilter]);
  const handleChangeAppliedFilter = useCallback((searchFilter, newAppliedFilter) => {
    onChangeAppliedFilter(searchFilter, newAppliedFilter);
  }, [onChangeAppliedFilter]);
  const ariaLabelID = "ListSearchFitler_Stack_".concat(searchFilter.id);
  const renderListSearchFilter = useMemo(() => {
    const listSearchFilterProps = {
      searchFilter: searchFilterTyped(searchFilter),
      appliedSearchFilter: appliedSearchFilter,
      onChangeAppliedFilter: handleChangeAppliedFilter,
      ariaLabeledBy: ariaLabelID
    };
    // console.log("renderListSearchFilter", searchFilter.id, listSearchFilterProps);
    switch (searchFilter.type) {
      case ListSearchFilterTypes.SingleSelect:
        return /*#__PURE__*/React.createElement(ListFilterSingleSelect, listSearchFilterProps);
        break;
      case ListSearchFilterTypes.MultiSelect:
        return /*#__PURE__*/React.createElement(ListFilterMultiSelect, listSearchFilterProps);
        break;
      case ListSearchFilterTypes.SingleRadio:
        return /*#__PURE__*/React.createElement(ListFilterSingleRadio, listSearchFilterProps);
        break;
      case ListSearchFilterTypes.MultiCheckbox:
        return /*#__PURE__*/React.createElement(ListFilterMultiCheckbox, listSearchFilterProps);
        break;
      case ListSearchFilterTypes.Text:
        return /*#__PURE__*/React.createElement(ListFilterText, listSearchFilterProps);
        break;
      case ListSearchFilterTypes.Number:
        return /*#__PURE__*/React.createElement(ListFilterNumber, listSearchFilterProps);
        break;
      case ListSearchFilterTypes.NumberRange:
        return /*#__PURE__*/React.createElement(ListFilterNumberRange, listSearchFilterProps);
        break;
      case ListSearchFilterTypes.Custom:
        return /*#__PURE__*/React.createElement(ListFilterCustom, listSearchFilterProps);
        break;
      default:
        return null;
    }
  }, [searchFilter, appliedSearchFilter, appliedSearchFilter === null || appliedSearchFilter === void 0 ? void 0 : appliedSearchFilter.filterValues,
  //needed to shallow compare changes
  handleChangeAppliedFilter]);
  return /*#__PURE__*/React.createElement(Box, {
    ref: ref,
    sx: {
      borderBottom: "solid 1px #ccc"
    },
    "data-testid": "ListSearchFitler_Base_".concat(searchFilter.id)
  }, /*#__PURE__*/React.createElement(Typography, {
    onClick: handleToggleOpen,
    id: "ListSearchFitler_Stack_".concat(searchFilter.id),
    variant: "h5",
    "data-testid": "ListSearchFitler_Stack_".concat(searchFilter.id)
  }, /*#__PURE__*/React.createElement(Stack, {
    sx: {
      p: 2,
      overflow: "hidden",
      cursor: "pointer"
    },
    direction: "row",
    spacing: 1
  }, /*#__PURE__*/React.createElement(Box, {
    id: ariaLabelID,
    sx: {
      flex: 1
    }
  }, label), appliedSearchFilter && /*#__PURE__*/React.createElement(Button, {
    disabled: !appliedSearchFilter,
    size: "small",
    sx: {
      height: 24
    },
    "aria-label": "".concat(labelClear, ": ").concat(label),
    onClick: handleClearFilter
  }, labelClear), canClose && (openState ? /*#__PURE__*/React.createElement(ExpandLessIcon, null) : /*#__PURE__*/React.createElement(ExpandMoreIcon, null)))), openState && /*#__PURE__*/React.createElement(Box, {
    sx: {
      p: 2,
      pt: 0,
      display: "block"
    },
    "data-testid": "ListSearchFitler_Expand_".concat(searchFilter.id)
  }, /*#__PURE__*/React.createElement(ErrorBoundary, {
    size: "small"
  }, renderListSearchFilter)));
});
export default ListSearchFilter;